import PropTypes from 'prop-types';
import React from 'react';
import { sanitizeTextWithHtml } from '../../shared/htmlSanitizer';

export class DangerousHTMLDiv extends React.Component {
  render() {
    return (
      <div data-qa-item={ this.props.qaTag }
        className={ this.props.className }
        dangerouslySetInnerHTML={ sanitizeTextWithHtml(this.props.html) }
      />
    );
  }
}

DangerousHTMLDiv.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
  qaTag: PropTypes.string,
};
